import React from 'react';

import TableExperimentalProvider, { propTypes, defaultProps } from './TableExperimentalProvider';
import TableSelfExperimental from './TableSelfExperimental';
import { TableProps } from './TableTypes';

import { forwardRef } from 'system';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TableExperimentalProps = TableProps<any>;

const TableExperimental = forwardRef(
  (props: TableExperimentalProps, ref: React.MutableRefObject<HTMLTableElement>): React.ReactElement => {
    return (
      <TableExperimentalProvider {...props} ref={ref}>
        <TableSelfExperimental />
      </TableExperimentalProvider>
    );
  }
);

TableExperimental.displayName = 'TableExperimental';
TableExperimental.propTypes = propTypes;
TableExperimental.defaultProps = defaultProps;

export default TableExperimental;
